import { useEffect, useState } from 'react'
import { getReportCardSettings, updateReportCardSettings } from '../api/reportCardSettingsApi'
import { appToast } from '../../../../components/AppToast'

export function useReportCardSettingsScreen() {
  const [formData, setFormData] = useState({
    id: '1',
    header: '',
    footer: '',
    gradeA: 90,
    gradeAName: 'Excellent',
    gradeB: 75,
    gradeBName: 'Very Good',
    gradeC: 60,
    gradeCName: 'Good',
    gradeD: 45,
    gradeDName: 'Satisfactory',
    gradeE: 35,
    gradeEName: 'Pass',
    absenteeMarksIncludeExclude: false,
    bodyFields: {
      testNo: true,
      subject: true,
      testDate: true,
      marks: true,
      outOf: true,
      percent: true,
      highest: true,
      grade: true,
      remark: true,
      topic: true,
    },
  })

  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    setIsLoading(true)
    setError('')

    getReportCardSettings()
      .then((data) => {
        if (!active) return
        setFormData(data)
      })
      .catch((err) => {
        if (!active) return
        setError(err?.message || 'Failed to load settings')
      })
      .finally(() => {
        if (active) setIsLoading(false)
      })

    return () => {
      active = false
    }
  }, [])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleGradeChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: isNaN(value) ? value : Number(value),
      [name]: value === '' ? '' : isNaN(value) ? value : parseInt(value, 10),
    }))
  }

  const handleBodyFieldChange = (fieldName) => {
    setFormData((prev) => ({
      ...prev,
      bodyFields: {
        ...prev.bodyFields,
        [fieldName]: !prev.bodyFields[fieldName],
      },
    }))
  }

  const insertTag = (fieldName, tag) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: prev[fieldName] ? prev[fieldName] + ' ' + tag : tag,
      [fieldName]: prev[fieldName] ? `${prev[fieldName]} ${tag}` : tag,
    }))
  }

  const handleSave = async () => {
    setError('')
    setIsSaving(true)
    try {
      await updateReportCardSettings(formData)
      const sanitizedPayload = {
        ...formData,
        gradeA: Number(formData.gradeA) || 0,
        gradeB: Number(formData.gradeB) || 0,
        gradeC: Number(formData.gradeC) || 0,
        gradeD: Number(formData.gradeD) || 0,
        gradeE: Number(formData.gradeE) || 0,
      }
      await updateReportCardSettings(sanitizedPayload)
      appToast.success('Report Card Settings updated successfully')
    } catch (err) {
      setError(err?.message || 'Failed to save settings')
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      formData,
      isLoading,
      isSaving,
      error,
    },
    actions: {
      handleChange,
      handleGradeChange,
      handleBodyFieldChange,
      insertTag,
      handleSave,
      setError,
    },
  }
}
